import FEGORender from '@futuweb/fego-render';
import FEGOEditor from '@futuweb/fego-editor';

const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10
};

function isH5() {
    let route = null;
    if (FEGORender) {
        const { store } = FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = FEGOEditor;
        route = project.route;
    }

    return route.now.pageType === PAGE_TYPE_ENUM.H5;
}

function getEntity() {
    // 获取插件配置
    return window._extra['tool-date-formatter']?.options?.entity;
}

export { isH5, getEntity };
